import Swal from 'sweetalert2';

// ✅ Success Alert (top-right toast)
export const showSuccess = (message = 'Success!') => {
    Swal.fire({
      icon: 'success',
      title: message,
      toast: true,
     position: 'bottom-end',

      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      background: '#d4edda',
      color: '#155724',
      customClass: {
        popup: 'custom-toast-margin'
      },
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });
  };
   

// ❌ Error Alert (top-right toast)
export const showError = (message = 'Something went wrong') => {
  Swal.fire({
    icon: 'error',
    title: message,
    toast: true,
   position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    background: '#f8d7da',
    color: '#721c24',
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
};
 

export const confirmAction = async (message = 'Are you sure?', confirmText = 'Yes, delete it!') => {
  const result = await Swal.fire({
    title: message,
    text: 'This action cannot be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: confirmText,
  });

  return result.isConfirmed;
};  